module.exports = __webpack_public_path__ + "img/art_3_7.8e5f890c.png";